import {
  UserPlusIcon,
  MegaphoneIcon,
  ArrowUpTrayIcon,
  WrenchScrewdriverIcon,
  UserGroupIcon,
  EyeSlashIcon,
  MapPinIcon,
  ClockIcon,
  Squares2X2Icon,
  DocumentTextIcon,
  PresentationChartLineIcon,
} from "@heroicons/react/24/outline";
import { NavigationItem } from "./types";

const navigation: NavigationItem[] = [
  {
    name: "Dashboard",
    href: "/stochastic",
    icon: Squares2X2Icon,
    current: false,
    internalName: "dashboard",
    roles: ["ROLE_SUPER_ADMIN", "ROLE_OWNER_GM", "ROLE_MARKETING"],
  },
  {
    name: "ROI Dashboard",
    href: "/stochastic/roi-dashboard",
    icon: PresentationChartLineIcon,
    current: false,
    internalName: "roi_dashboard",
    roles: ["ROLE_SUPER_ADMIN", "ROLE_OWNER_GM", "ROLE_MARKETING"],
  },
  {
    name: "Prospects",
    href: "/stochastic/prospects",
    icon: UserPlusIcon,
    current: false,
    internalName: "prospects",
    roles: ["ROLE_SUPER_ADMIN", "ROLE_OWNER_GM", "ROLE_MARKETING"],
  },
  {
    name: "Customers",
    href: "/stochastic/customers",
    icon: UserGroupIcon,
    current: false,
    internalName: "customers",
    roles: ["ROLE_SUPER_ADMIN", "ROLE_OWNER_GM", "ROLE_MARKETING"],
  },
  {
    name: "Invoices",
    href: "/stochastic/invoices",
    icon: DocumentTextIcon,
    current: false,
    internalName: "invoices",
    roles: ["ROLE_SUPER_ADMIN", "ROLE_OWNER_GM", "ROLE_MARKETING"],
  },
  {
    name: "Locations",
    href: "/stochastic/locations",
    icon: MapPinIcon,
    current: false,
    internalName: "locations",
    roles: ["ROLE_SUPER_ADMIN", "ROLE_OWNER_GM", "ROLE_MARKETING"],
  },
  {
    name: "Campaign Management",
    href: "/stochastic/campaigns",
    icon: MegaphoneIcon,
    current: false,
    internalName: "campaigns",
    roles: ["ROLE_SUPER_ADMIN", "ROLE_OWNER_GM", "ROLE_MARKETING"],
  },
  {
    name: "Uploads",
    href: "#",
    icon: ArrowUpTrayIcon,
    current: false,
    internalName: "dashboards",
    roles: ["ROLE_SUPER_ADMIN", "ROLE_MARKETING"],
    children: [
      {
        name: "Field Service Import",
        href: "/stochastic/field-service-import",
        icon: WrenchScrewdriverIcon,
        current: false,
        internalName: "field_service_import",
        roles: ["ROLE_SUPER_ADMIN", "ROLE_MARKETING"],
      },
      {
        name: "Prospect Source Import",
        href: "/stochastic/prospect-source-import",
        icon: UserPlusIcon,
        current: false,
        internalName: "prospect_source_import",
        roles: ["ROLE_SUPER_ADMIN", "ROLE_MARKETING"],
      },
      {
        name: "Do Not Mail Import",
        href: "/stochastic/do-not-mail-import",
        icon: EyeSlashIcon,
        current: false,
        internalName: "do_not_mail_import",
        roles: ["ROLE_SUPER_ADMIN", "ROLE_MARKETING"],
      },
      {
        name: "Import Status",
        href: "/stochastic/import-status",
        icon: ClockIcon,
        current: false,
        internalName: "import_status",
        roles: ["ROLE_SUPER_ADMIN", "ROLE_MARKETING"],
      },
    ],
  },
];

const stochasticConfig = {
  sectionName: "stochastic",
  defaultRoute: "/stochastic",
  navigation,
};

export default stochasticConfig;
